import React from 'react';
import Select from 'react-select';
import { INCREASE_REPORT_STATUSES } from '../../../../../constants/defaultValues';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeIncreaseReportsPage,
    changeIncreaseReportsSelectedStatus,
    getIncreaseReports,
} from '../../../../../store/actions/increase-reports';

const Status = ({ generateParams }) => {
    const dispatch = useDispatch();

    const selectedStatus = useSelector(state => state.increaseReports.selectedStatus);

    const options = INCREASE_REPORT_STATUSES.map(period => ({
        value: period.id,
        label: period.label,
    }));

    const selectedOption = options.find(option => option.value === selectedStatus);

    const onStatusChange = status => {
        dispatch(changeIncreaseReportsSelectedStatus(status.value));
        dispatch(changeIncreaseReportsPage(1));
        dispatch(
            getIncreaseReports(generateParams({ statusParam: status.value, currentPageParam: 1 }))
        );
    };

    return (
        <>
            <Select
                className='common-select common-select--filters'
                classNamePrefix='common'
                menuPlacement={'auto'}
                isSearchable={false}
                value={selectedOption}
                onChange={onStatusChange}
                options={options}
            />
        </>
    );
};

export default Status;
